import { render, staticRenderFns } from "./PendingTransfersScotiabank.vue?vue&type=template&id=114e4e14&lang=pug"
import script from "./PendingTransfersScotiabank.vue?vue&type=script&lang=js"
export * from "./PendingTransfersScotiabank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports